var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-sider',{class:[
    'sider',
    _vm.isDesktop() ? null : 'shadow',
    _vm.theme,
    _vm.fixSiderbar ? 'ant-fixed-sidemenu' : null
  ],attrs:{"width":"200px","collapsible":_vm.collapsible,"trigger":null},model:{value:(_vm.collapsed),callback:function ($$v) {_vm.collapsed=$$v},expression:"collapsed"}},[_c('logo'),_c('s-menu',{style:(_vm.smenuStyle),attrs:{"collapsed":_vm.collapsed,"menu":_vm.menus,"theme":_vm.theme,"mode":_vm.mode},on:{"select":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }